import { useCallback, useEffect } from "react";
import Form from "rc-field-form";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { Input, Label } from "reactstrap";
import DateInput from "../../../../components/Inputs/DateInput";
import CustomTimeInput from "../../../../components/Inputs/CustomTimeInput";
import Field from "../../../../components/Field";
import Button from "../../../../components/Button";
import { combineDateAndTime } from "../../../../utils/helpers/date";
import { generateErrorsConfigForForm } from "../../../../utils/helpers/errors";

function MissPunch({ values, onClose, error, loading, onFinish }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const onCancel = useCallback(() => {
        form.resetFields();
        onClose();
    }, [form, onClose]);

    useEffect(() => {
        form.setFieldValue("endDate", values?.data?.endDate);
        form.setFieldValue("note", values?.data?.note);
    }, [form, values?.data?.endDate]);

    useEffect(() => {
        const fieldErrors = generateErrorsConfigForForm(
            ["endDate"], error
        );
        form.setFields(fieldErrors);
    }, [error, form]);

    return (
        <Form
            className="p-4 h-100"
            form={form}
            onFinish={onFinish}
        >
            <div style={{ height: "calc(100% - 50px)" }}>
                <div className="mb-3">
                    <Label>{t("date")}</Label>
                    <DateInput disabled={true} value={moment(values?.data?.date).toDate()} />
                </div>

                <div className="mb-3">
                    <Label>{t("start-time")}</Label>
                    <CustomTimeInput value={moment(values?.data?.startDate).parseZone()} disabled={true} />
                </div>

                <Field
                    label={t("end-time")}
                    name="endDate"
                    rules={[
                        {
                            required: true,
                            message: t("required-end-time")
                        },
                        {
                            validator: (_, value) => {
                                if (value) {
                                    const { date, startDate, timezone } = values?.data;
                                    let end = combineDateAndTime(moment(date), moment(value), timezone);
                                    if (moment(end).isSame(moment(startDate), "seconds")) {
                                        return Promise.reject(
                                            new Error(t("end-date-bigger-than-start-date"))
                                        );
                                    }
                                }
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <CustomTimeInput />
                </Field>

                <Field label={t("note")} name="note">
                    <Input
                        resize="none"
                        rows="7"
                        type="textarea"
                        className="h-100"
                        placeholder={t("note")}
                    />
                </Field>
            </div>

            <div className="d-flex justify-content-end">
                <Button
                    type="button"
                    color="muted"
                    disabled={loading}
                    onClick={onCancel}
                >
                    {t("close")}
                </Button>
                <Button color="primary" loading={loading} disabled={loading}>
                    {t("edit")}
                </Button>
            </div>
        </Form>
    );
}

export default MissPunch;
